<template>
  <v-form class="px-2" v-model="valid" ref="registerForm">
    <h3 class="display-1 font-weight-bold">Register</h3>
    <v-layout row wrap class="align-center">
      <v-flex grow>
        <v-text-field
            v-model="name"
            label="Name of Instaplay"
            :rules="[v => !!v || 'required']"
            required
        ></v-text-field>
      </v-flex>
      <v-flex shrink>
        <v-layout row class="align-center">
          <v-avatar
              v-if="imageInput.url"
              :size="50"
              class="mx-2"
          >
            <img :src="imageInput.url" :alt="imageInput.name">
          </v-avatar>
          <image-input
              ref="i_image"
              accept="image/*"
              @file-update="(file) => { update(file, imageInput) }"
              :show-remove="!!imageInput.name"
              round
              flat
              small
          ></image-input>
        </v-layout>
      </v-flex>
    </v-layout>

    <v-select
        v-model="category"
        :items="categoryItems"
        :rules="[v => !!v || 'required']"
        label="Category"
    ></v-select>

    <v-text-field
        v-model="prompt"
        label="Instaplay Prompt"
        :rules="[v => !!v || 'required']"
        required
    ></v-text-field>

    <v-checkbox
        v-model="partOfTournament"
        label="Part of tournament"
    ></v-checkbox>

    <v-select
        v-if="partOfTournament"
        v-model="tournament"
        :items="tournamentItems"
        @click:prepend="loadItems"
        :prepend-icon="isItemError? 'refresh' : ''"
        :loading="isItemLoading"
        :rules="[v => !partOfTournament || !!v || 'required']"
        label="Select Tournament"
    ></v-select>

    <v-layout row wrap v-if="showNameOfTournament" class="align-center">
      <v-flex grow>
        <v-text-field
            v-model="newTournament"
            label="Name of Tournament"
            :rules="[v => !showNameOfTournament || !!v || 'required']"
            required
        ></v-text-field>
      </v-flex>
      <v-flex shrink>
        <v-layout row class="align-center">
          <v-avatar
              v-if="tournamentImageInput.url"
              :size="50"
              class="mx-2"
          >
            <img :src="tournamentImageInput.url" :alt="tournamentImageInput.name">
          </v-avatar>
          <image-input
              ref="t_image"
              accept="image/*"
              @file-update="(file) => { update(file, tournamentImageInput) }"
              :show-remove="!!tournamentImageInput.name"
              round
              flat
              small
          ></image-input>
        </v-layout>
      </v-flex>
    </v-layout>
    <v-layout row>
      <v-spacer></v-spacer>
      <v-btn round color="warning" @click="submit" :disabled="!valid">next</v-btn>
    </v-layout>
  </v-form>
</template>

<script>
    import ImageInput from "@/components/ImageInput";
    import {createHelpers} from 'vuex-map-fields';
    import {mapGetters} from "vuex";

    const {mapFields} = createHelpers({
        getterType: 'instaplayForm/register/getRegisterField',
        mutationType: 'instaplayForm/register/updateRegisterField',
    });
    export default {
        name: "Register",
        components: {ImageInput},
        props: {
            edit: {
                default: false,
                type: Boolean
            }
        },
        data() {
            return {
                valid: false,
                imageInput: {
                    name: '',
                    url: '',
                    file: ''
                },
                itemsLoaded: false,
                tournamentImageInput: {
                    name: '',
                    url: '',
                    file: ''
                },
            }
        },
        computed: {
            ...mapFields([
                'name',
                'category',
                'categoryItems',
                'prompt',
                'image',
                'partOfTournament',
                'tournament',
                'tournamentImage',
                'newTournament',
                'tournamentItems'
            ]),
            ...mapGetters('instaplayForm', ['isItemLoading', 'isItemSuccess', 'isItemError']),
            showNameOfTournament: function () {
                return this.tournament === 'new' && this.partOfTournament
            },
            imageUrl: function () {
                return this.imageInput.url
            },
            tournamentImageUrl: function () {
                return this.tournamentImageInput.url
            }
        },
        methods: {
            submit: function () {
                this.$emit('setState', 2)
                //submit the form...
            },
            loadItems() {
                if (!this.itemsLoaded) {
                    this.$store.dispatch('instaplayForm/register/getTournaments')
                        .then(() => {
                            if (this.isItemSuccess)
                                this.itemsLoaded = true
                        })
                }
            },
            reset: function () {
                if (this.$refs.i_image)
                    this.$refs.i_image.clear()
                if (this.$refs.t_image)
                    this.$refs.t_image.clear()
                this.loadImages()
            },
            update: function (file, obj) {
                if (file) {
                    obj.file = file // this file can be sent to server...
                    obj.name = file.name
                    const fr = new FileReader()
                    fr.readAsDataURL(file)
                    fr.addEventListener('load', () => {
                        obj.url = fr.result
                    })
                } else {
                    obj.url = ''
                    obj.name = ''
                    obj.file = ''
                }
            },
            loadImages() {
                if (this.edit)
                    this.imageInput.url = this.$store.state.instaplayForm.register.form.image
            },
        },
        watch: {
            valid: function (val) {
                this.$emit('input', val)
            },
            imageUrl: function (val) {
                this.image = val
            },
            tournamentImageUrl: function (val) {
                this.tournamentImage = val
            },
            partOfTournament: function (val) {
                if (val)
                    this.loadItems()
            }
        }
    }
</script>

<style scoped>

</style>
